import { List, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { itemList, itemWrapper } from "../../styles/frequentListStyles";
import ShoppingListItem from "../ShoppingList/ShoppingListItem";

export const ItemsList = ({ activeList, updateItemInList, deleteItemFromList }) => {
  const { t } = useTranslation();

  const items = activeList?.shoppingListItems || [];

  if (items.length === 0) {
    return (
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        {t("frequentItems.emptyListMessage")}
      </Typography>
    );
  }

  const handleUpdateItem = (index, updatedItem) => {
    updateItemInList(activeList.id, index, updatedItem);
  };

  const handleDeleteItem = (index) => {
    deleteItemFromList(activeList.id, index);
  };

  return (
    <List sx={itemList}>
      {items.map((item, index) => (
        <div key={index} style={itemWrapper}>
          <ShoppingListItem item={item} index={index} onUpdateItem={handleUpdateItem} onDeleteItem={handleDeleteItem} hidePurchased={true} />
        </div>
      ))}
    </List>
  );
};

export default ItemsList;
